import { getWcBrand } from '../../../src/worldcup/helpers/wcBrand.helper';

export const getLeaderboardComingSoonSubtitle = (competitionName?: string): string =>
  `Rankings will go live once ${competitionName ?? getWcBrand().NAME} kicks off and more players join the competition.`;

export const LEADERBOARD_MIN_SHOW_THRESHOLD = 50;

export const LEADERBOARD_VIEW_COPY = {
  TOP_HEADER_TITLE: 'Top 50',
  TOP_HEADER_SUBTITLE: 'The best predictors worldwide',
  FUTURES_HIDDEN_BANNER: "Everyone's winner & top-scorer picks stay hidden until the first match kicks off.",
  LIVE_RANKING_NOTE: 'Live points are shown on each card. Global rankings update once each match ends.',
  EMPTY_ICON: '🏆',
  EMPTY_TITLE: 'Leaderboard coming soon',
  EMPTY_SUBTITLE: 'Rankings will appear once the tournament begins and predictions are scored.',
  ERROR_TITLE: "Couldn't load leaderboard",
  ERROR_SUBTITLE: 'Check your connection and try again.',
  ERROR_RETRY: 'Try again',
  COMING_SOON_BADGE: 'Coming Soon',
  COMING_SOON_TITLE: 'Global Leaderboard',
} as const;

export const LEADERBOARD_COPY = {
  TITLE: 'Leaderboard',
  PARTICIPANTS_LABEL: 'Participants',
  COL_RANK: 'Rank',
  COL_USER: 'User',
  COL_WINNER_SCORER: 'Winner/Scorer',
  COL_STATS: 'Stats',
  COL_POINTS: 'Points',
} as const;
